import RBush from 'rbush';

import { createTileClass } from './FrecklesPointTile';
import { IFrecklesFeatureProperties, IFrecklesRBushItem } from '../../../types/freckles';
import { getExtendedTileBBox } from '../../tile';

export type TFeature = GeoJSON.Feature<GeoJSON.Point, IFrecklesFeatureProperties>;

interface IFrecklesPointsLayerOptions {
  map: YMaps.Map;
  rbush: RBush<IFrecklesRBushItem>;
}

export function defineFrecklesPointsLayer(ymaps: YMaps.IYMaps) {
  if (ymaps.modules.isDefined('FrecklesPointsLayer')) {
    return;
  }

  ymaps.modules.define<[YMaps.util.IHd, YMaps.util.IPixelBounds, YMaps.option.Manager, typeof YMaps.Layer]>(
    'FrecklesPointsLayer',
    ['util.hd', 'util.pixelBounds', 'option.Manager', 'Layer', 'layer.tileContainer.DomContainer'],
    (provide, utilHd, utilPixelBounds, optionManager, Layer) => {
      class FrecklesPointsLayer {
        public readonly layer: YMaps.Layer;
        private map: YMaps.Map;
        private mapProjection: YMaps.projection.wgs84Mercator;
        private rbush: RBush<IFrecklesRBushItem>;

        public constructor(options: IFrecklesPointsLayerOptions) {
          this.map = options.map;
          this.mapProjection = this.map.options.get('projection');
          this.rbush = options.rbush;

          this.layer = new Layer(() => null, {
            tileTransparent: true,
            tileClass: createTileClass({
              getFeaturesForTile: (tileNumber, tileZoom) => this.getFeaturesForTile(tileNumber, tileZoom),
              mapProjection: this.mapProjection,
              dpr: utilHd.getPixelRatio(),
            }),
            tileContainerClass: 'default#dom',
          });
        }

        private getFeaturesForTile(tileNumber: YMaps.TTileNumber, zoom: number): TFeature[] {
          const extendedTileBBox = getExtendedTileBBox({
            tileNumber,
            zoom,
            includeShadow: true,
          });
          const rBushItems = this.rbush.search(extendedTileBBox);

          return rBushItems.map(({ feature }) => feature);
        }
      }

      provide(FrecklesPointsLayer);
    },
  );
}
